import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog_Confirmation } from '@app/styles';
import { ComponentSync } from '@nu-art/thunderstorm-frontend';
import { flatArray, removeItemFromArray, StaticLogger } from '@nu-art/ts-common';
import { ModuleFE_Pathway, ModuleFE_PathwayTransition } from '../../../../../_entity.js';
import { Renderer_Transition } from '../../../../Page_PathwayEditor/renderers/Renderer_Transition.js';
import { Renderer_PathwayItemChildSelector } from '../../../../Page_PathwayEditor/renderers/Renderer_PathwayItemChildSelector.js';
export class Dialog_DeletePathwayTransition extends ComponentSync {
    static show = (sProps) => {
        const transition = ModuleFE_PathwayTransition.cache.unique(sProps.transitionId);
        if (!transition)
            return;
        const props = { pathwayIds: [sProps.pathwayId], transition };
        Dialog_Confirmation.show({
            header: 'Delete Transition?',
            content: () => _jsx(Dialog_DeletePathwayTransition, { ...props }),
            buttons: [
                {
                    label: 'Yes, Delete',
                    isAsync: true,
                    action: async () => {
                        try {
                            await ModuleFE_PathwayTransition._v1.deletePathwayTransition({
                                transitionsToRemove: [transition],
                                pathwayIds: props.pathwayIds,
                            }).executeSync();
                            sProps.onDeleteCB?.();
                        }
                        catch (err) {
                            StaticLogger.logError('Dialog_DeletePathwayTransition', 'Failed deleting pathway transition', err);
                        }
                    }
                },
                {
                    label: 'Don\'t Delete',
                    isPreferred: true,
                    action: () => {
                    }
                }
            ]
        });
    };
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.transition = nextProps.transition;
        state.pathway = ModuleFE_Pathway.cache.unique(nextProps.pathwayIds[0]);
        state.childPathwayIds = this.inferRecursiveChildPathwayIds(state.pathway._id);
        return state;
    }
    // ######################## Logic ########################
    inferRecursiveChildPathwayIds(parentPathwayId) {
        const directChildren = ModuleFE_Pathway.getChildren(parentPathwayId);
        return flatArray(directChildren.map(child => {
            return [
                child._id,
                ...this.inferRecursiveChildPathwayIds(child._id),
            ];
        }));
    }
    // ######################## Render ########################
    render() {
        return _jsxs(_Fragment, { children: [_jsx("div", { children: "You're about to delete transition" }), _jsx(Renderer_Transition, { transition: this.state.transition }), this.render_PathwaySelection()] });
    }
    render_PathwaySelection = () => {
        return _jsx(Renderer_PathwayItemChildSelector, { pathwayId: this.state.pathway._id, childFilter: child => this.state.childPathwayIds.includes(child._id), onChangeCallback: (newPathwayIds) => {
                //Remove all ids that are in the original but not in new
                this.props.pathwayIds.forEach(id => {
                    if (!newPathwayIds.includes(id))
                        removeItemFromArray(this.props.pathwayIds, id);
                });
                //Add new ids to original
                newPathwayIds.forEach(id => {
                    if (!this.props.pathwayIds.includes(id))
                        this.props.pathwayIds.push(id);
                });
            } });
    };
}
//# sourceMappingURL=Dialog_DeletePathwayTransition.js.map